import ClientTypeOptInState from 'owa-service/lib/contract/ClientTypeOptInState';
import { getCookie, updateCookie } from './browserCookieWrapper';

export const OPT_IN_COOKIE_NAME: string = 'OptInPrg';

export function isClientOptingReact(): boolean {
    return isClientOpting(ClientTypeOptInState.React);
}

export function isClientOptingJsmvvm(): boolean {
    return isClientOpting(ClientTypeOptInState.Jsmvvm);
}

function isClientOpting(client: ClientTypeOptInState): boolean {
    const optinCookieValue = getCookie(OPT_IN_COOKIE_NAME);
    return optinCookieValue == '' + client;
}

export function updateClientOptInStateCookie(value: ClientTypeOptInState) {
    if (value == null) {
        updateCookie(OPT_IN_COOKIE_NAME);
    } else {
        updateCookie(OPT_IN_COOKIE_NAME, '' + value, { path: '/' });
    }
}
